<div class="modal-container">
  <div mat-dialog-title>
    <div class="modal__header">
      <div class="modal__title">
        <h1>Edit margin</h1>
      </div>
      <button
        class="close-button"
        mat-dialog-close>
        <i class="material-symbols-rounded">close</i>
      </button>
    </div>
  </div>

  <mat-dialog-content aria-label="Generic modal">
    <div class="modal__body">
      <div class="inputs-block mt-4">
        <div>
          <scope-ui-input
            [initialValue]="outputMargins.fromTop?.toString()"
            [inputLabel]="'Top margin'"
            [type]="'number'"
            [minimum]="0"
            [maximum]="31"
            (onInputBlurChange)="outputMargins.fromTop = $event"
            (onInputChange)="outputMargins.fromTop = $event" />
        </div>
        <div>
          <scope-ui-input
            [initialValue]="outputMargins.fromBottom?.toString()"
            [inputLabel]="'Bottom margin'"
            [type]="'number'"
            [minimum]="0"
            [maximum]="31"
            (onInputChange)="outputMargins.fromBottom = $event"
            (onInputBlurChange)="outputMargins.fromBottom = $event" />
        </div>
      </div>

      <div class="inputs-block mt-4">
        <div>
          <scope-ui-input
            [initialValue]="outputMargins.fromLeft?.toString()"
            [inputLabel]="'Left margin'"
            [type]="'number'"
            [minimum]="0"
            [maximum]="31"
            (onInputChange)="outputMargins.fromLeft = $event"
            (onInputBlurChange)="outputMargins.fromLeft = $event" />
        </div>
        <div>
          <scope-ui-input
            [initialValue]="outputMargins.fromRight?.toString()"
            [inputLabel]="'Right margin'"
            [type]="'number'"
            [minimum]="0"
            [maximum]="31"
            (onInputChange)="outputMargins.fromRight = $event"
            (onInputBlurChange)="outputMargins.fromRight = $event" />
        </div>
      </div>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions class="scope-actions">
    <button
      (click)="applyMarginSettings()"
      [disabled]="!isFormValid()"
      mat-button
      class="scope-ui-modal-flat-button">
      <span class="font-newJuneBold">Save</span>
    </button>
  </mat-dialog-actions>
</div>
